import {createContext, useContext, useState, useMemo} from "react";
import {numberFormat4FractionalDigits, numberFormatIntegerStr} from "utils/NumberUtils";
import {TRADES_LIST_TRADE_BREAKS} from "../../../service/UrlConstant";
import {SecurityContext} from "../../../context/security";
import "./TradeCaptureContext"
import {getSessionAttribute, setSessionAttribute} from "../../../utils/SessionUtils";
import {
    ACCOUNTS_OPTIONS_NO_SWAP,
    dropDownOptionAll,
    SELECTED_TRADE_BREAKS_ACCOUNT,
    SELECTED_TRADE_BREAKS_ENTITY,
    TRADE_BREAK_AGRID_FILTER_STATE
} from "../../../utils/Constants";
import {EntityAccountsContext} from "../../../components/entity-accounts/context";

export const Context = createContext({});

export const Provider = props => {
    const {children} = props;
    const [showInfoModal, setShowInfoModal] = useState(false);
    const [selectedBrkType, setSelectedBrkType] = useState();
    const [highlightTradeEntryFields, setHighlightTradeEntryFields] = useState({})
    const [tradeBreakFilterClearClicked, setTradeBreakFilterClearClicked] = useState(false);

    const initialCurEntityAccount = {
        managerId: '',
        managerName: '',
        accountId: '',
        accountName: '',
        accountCode: null,
        formErrors: {search: {}},
        showAccounts: true,
        disableAccounts : false,
        validateAccount:true
    };

    const defaultCurAccountsOptions = {
        accountId: dropDownOptionAll,
        name: dropDownOptionAll,
        accountCode: dropDownOptionAll,
    };

    const [curEntityAccounts, setCurEntityAccounts] = useState(JSON.parse(JSON.stringify(initialCurEntityAccount)));
    const [curAccountsOptions, setCurAccountsOptions] = useState([]);
    const { entityAccountsOptionsNoSwap, setEntityAccountsOptionsNoSwap, getMemoizedEntityAccountsNoSwap} = useContext(EntityAccountsContext);

    const initTradeBreakFilterState = {
        security: null,
        breakType: 'ALL',
    }
    const initPopUpDataState = [
        {'field':'tradeDate','header':'Trade Date','client':'','broker':'', isBreak:false},
        {'field':'settleDate','header':'Settle Date','client':'','broker':'', isBreak:false},
        {'field':'security','header':'Security','client':'','broker':'', isBreak:false},
        {'field':'symbol','header':'Symbol','client':'','broker':'', isBreak:false},
        {'field':'brokerCode','header':'Broker Code','client':'','broker':'', isBreak:false},
        {'field':'tranType','header':'Tran Type','client':'','broker':'', isBreak:false},
        {'field':'price','header':'Price','client':'','broker':'', isBreak:false},
        {'field':'quantity','header':'Quantity','client':'','broker':'', isBreak:false},
        {'field':'net','header':'Net','client':'','broker':'', isBreak:false},
        {'field':'interest','header':'Interest','client':'','broker':'', isBreak:false},
        {'field':'commission','header':'Commission','client':'','broker':'', isBreak:false},
        {'field':'execBroker','header':'Exec Brk','client':'','broker':'', isBreak:false},
        {'field':'dtcControlNumber','header':'DTC Control Number','client':'','broker':'', isBreak:false},
        {'field':'reason','header':'Reason','client':'','broker':'', isBreak:false},
    ]
    const [selectedBreak, setSelectedBreak] = useState({});
    const [popUpData, setPopUpData] = useState(JSON.parse(JSON.stringify(initPopUpDataState)));
    const [viewClicked, setViewClicked] = useState(false);
    const [gridApi, setGridApi] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [gridColumnApi,setGridColumnApi] = useState(null);
    const [tradeBreakFilterState, setTradeBreakFilterState] = useState(JSON.parse(JSON.stringify(initTradeBreakFilterState)));
    const [gridApiOriginal, setGridApiOriginal] = useState(null);



    const [isTradeBreaksFilterOpen, setIsTradeBreaksFilterOpen] = useState(false);

    const tradeBreakTypeHashmap = {
        "BRKS":"Client Only",
        "UNCN":"Broker Only",
        "MTPT":"Match with Differences",
        "MTCH":"Matches",
        "CACN":"Cancels"
    }
    const fieldToReasonColMapping = {
        'quantity': 'NetQuantity',
        'net': 'NetAmount',
        'execbroker': 'Executing Broker',
        'price':'Price',
        'settledate':'Settlement Date',
        'commission':'Commission',
        'interest':'Interest'
    }

    const getReasonEquivalentOfField =(field)=> {
        if(!!field)
            field = field.replace('broker','').replace('client','').toLowerCase()
        return fieldToReasonColMapping[field];
    }

    const mapTradeBreakType = (param) => {
        if(!!param)
            return tradeBreakTypeHashmap[param.data.breakType]
        return ''
    }

    const clientOrBrokerData = (param) => {
        if(!!param){
            if(param.data){
                let returnValue
                Object.entries(param?.data).map(([key, value]) => {
                    if(key.replace('client','').toLowerCase()===param.colDef.field.toLowerCase()){
                        returnValue = value
                        return value;
                    }
                    if(key.replace('broker','').toLowerCase()===param.colDef.field.toLowerCase()){
                        if(param.colDef.field === 'ExecBroker' && !!value && value.trim().length === 8){
                            value = value.trim().substring(4,8)
                        }
                        returnValue = value
                        return value;
                    }
                })
                return returnValue
            }
        }
        return ''
    }

    const accountCodeMapping = (param) =>{
        if(!!param)
            return param.data.breakType === 'UNCN'? param.data.brokerAccountCode : param.data.clientAccountCode;
        return ''
    }

    const cellStyleChecker=(param)=>{
        let columnName = param.colDef.field;
        let reason = param.data.clientReason;
        if (checkColumnInReason(columnName,reason)) return {backgroundColor: '#F7E8E9', color:'#AE1100'}
        return
    }

    const numericCellStyleChecker=(param)=>{
        const numericStyle = {textAlign: 'right'};
        return {...numericStyle,...cellStyleChecker(param)}
    }

    const checkColumnInReason=(columnName,reason)=>{
        if(!!reason && !!columnName && reason.includes(getReasonEquivalentOfField(columnName)))
            return true;
        return false
    }

    const {
        makeGetRequest
    } = useContext(SecurityContext);

    const clearFilterData = () => {

        setSessionAttribute(TRADE_BREAK_AGRID_FILTER_STATE, null);
        gridApi?.setFilterModel(null);
        setRowData([]);
        //gridApiOriginal?.setFilterModel(null);

    }

    const loadTradeBreaksList = () => {
        /*
        const tradeBreakFilterRefreshClicked = getSessionAttribute(TRADE_BREAK_FILTER_REFRESH_CLICKED) || false;
        if(!tradeBreakFilterRefreshClicked){
            clearFilterData();
        }
         */

        if(!rowData.length > 0) {
            const onSuccess = (response) => {
                if (!!response.data && response.data.length > 0) {
                    setRowData([...response.data]);
                }
                gridColumnApi?.resetColumnState();
            }
            const onError = (err) => {
                console.error("Trade Breaks data", err);
                setRowData([]);
            }

            makeGetRequest(TRADES_LIST_TRADE_BREAKS, {}, onSuccess, onError);
        }
    };

    const loadTradeBreaksListWithParams = (searchCriteria) => {
        //clearFilterData();

        const onSuccess = (response) => {
            if(!!response.data && response.data.length > 0){
                setRowData([...response.data]);
            }
            else {
                setRowData([]);
            }
            gridColumnApi?.resetColumnState();
        }
        const onError = (err) => {
            console.error("Trade Breaks data",err);
            setRowData([]);
        }

        makeGetRequest(TRADES_LIST_TRADE_BREAKS, searchCriteria, onSuccess, onError);
    };

    const getRefreshCriteria = () => {
        const correspondingEntity = getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP)?.find((entity) => entity.managerId === curEntityAccounts.managerId);
        return {
            "entity": (correspondingEntity?.shortName === dropDownOptionAll ? "" : correspondingEntity?.shortName),
            "account": (curEntityAccounts?.accountId === dropDownOptionAll ? "" : curEntityAccounts?.accountId),
            "security": tradeBreakFilterState.security,
            "breakType": tradeBreakFilterState.breakType && tradeBreakFilterState.breakType === "ALL" ? null : tradeBreakFilterState.breakType
        };
    }

    const columnDefsTradeBreaks = [
        {headerName: 'id', field: 'id', hide: true, suppressColumnsToolPanel:true},
        {headerName: 'Break Type', field: 'breakType', width:'185', valueGetter:mapTradeBreakType, cellRenderer: 'agGroupCellRenderer'},
        {headerName: 'Entity', field: 'shortName', width:'100'},
        {headerName: 'Account', field: 'accountCode', width:'105', valueGetter:accountCodeMapping},
        {headerName: 'Security', field: 'security', width:'105'},
        {headerName: 'CCY', field: 'tradeCcy', width:'105'},
        {headerName: 'Front Exec', field: 'brokerCode', width:'105'},

        //I am keeping these columns hidden so that the export function shows the same data it did previously
        {headerName: 'Trade Date', field: 'clientTradeDate', hide: true},
        {headerName: 'Settle Date', field: 'clientSettleDate', hide: true},
        {headerName: 'Tran Type', field: 'clientTranType', hide: true},
        {headerName: 'Price', field: 'clientPrice', hide: true, cellStyle:numericCellStyleChecker},
        {headerName: 'Quantity', field: 'clientQuantity', hide: true, valueFormatter: numberFormatIntegerStr},
        {headerName: 'Net', field: 'clientNet',hide: true, valueFormatter: params => params.value ? numberFormat4FractionalDigits(params): '', cellStyle:numericCellStyleChecker},
        {headerName: 'Interest', field: 'clientInterest', hide: true},
        {headerName: 'Commission', field: 'clientCommission', hide: true},
        {headerName: 'Exec Brk', field: 'clientExecBroker', hide: true},

        {headerName: 'Trade Date', field: 'brokerTradeDate',hide: true},
        {headerName: 'Settle Date', field: 'brokerSettleDate',hide: true},
        {headerName: 'Tran Type', field: 'brokerTranType',hide: true},
        {headerName: 'Price', field: 'brokerPrice',hide: true},
        {headerName: 'Quantity', field: 'brokerQuantity',hide: true, valueFormatter: numberFormatIntegerStr},
        {headerName: 'Net', field: 'brokerNet', hide: true, valueFormatter: params => params.value ? numberFormat4FractionalDigits(params): '', cellStyle:numericCellStyleChecker},
        {headerName: 'Interest', field: 'brokerInterest',hide: true},
        {headerName: 'Commission', field: 'brokerCommission',hide: true},
        {headerName: 'Exec Brk', field: 'brokerExecBroker',hide: true},
        {headerName: 'DTC Control Number', field: 'brokerDtcControlNumber', hide: true},
        {headerName: 'Reason', field: 'brokerReason', hide: true},

        // {headerName: '', field: 'brokerCode', flex: 1},
    ];

    const columnDefsTradeBreaksOriginal = [

        {headerName: '', marryChildren:true, children:[
                {headerName: 'id', field: 'id', hide:true, suppressColumnsToolPanel:true},
                {headerName: 'Break Type', field: 'breakType', valueGetter:mapTradeBreakType, pinned:'left', width:'115'},
                {headerName: 'Entity', field: 'shortName', pinned:'left', width:'90'},
                {headerName: 'Account', field: 'accountCode',valueGetter:accountCodeMapping, pinned:'left', width:'100'},
                {headerName: 'Security', field: 'security', pinned:'left', width:'100'},
                {headerName: 'CCY', field: 'tradeCcy', pinned:'left', width:'100'},
                {headerName: 'Front Exec', field: 'brokerCode', pinned:'left', width:'100'},
            ]},


        {headerName:'Client', marryChildren:true, children:[

                {headerName: 'Trade Date', field: 'clientTradeDate', width:115},
                {headerName: 'Settle Date', field: 'clientSettleDate', width:115},
                {headerName: 'Tran Type', field: 'clientTranType', width:110},
                {headerName: 'Price', field: 'clientPrice',width:95, cellStyle:numericCellStyleChecker},
                {headerName: 'Quantity', field: 'clientQuantity', width:105, valueFormatter: numberFormatIntegerStr , cellStyle:numericCellStyleChecker},
                {headerName: 'Net', field: 'clientNet',width:95, valueFormatter: params => params.value ? numberFormat4FractionalDigits(params): '', cellStyle:numericCellStyleChecker},
                {headerName: 'Interest', field: 'clientInterest', width:100, cellStyle:numericCellStyleChecker},
                {headerName: 'Commission', field: 'clientCommission', width:125, cellStyle:numericCellStyleChecker},
                {headerName: 'Exec Brk', field: 'clientExecBroker', width:100},
            ]},
        {headerName:'Broker', marryChildren:true, children:[
                {headerName: 'Broker Code', field: 'brokerCode',width:125},
                {headerName: 'Trade Date', field: 'brokerTradeDate',width:115},
                {headerName: 'Settle Date', field: 'brokerSettleDate',width:115},
                {headerName: 'Tran Type', field: 'brokerTranType',width:110},
                {headerName: 'Price', field: 'brokerPrice',width:95},
                {headerName: 'Quantity', field: 'brokerQuantity',width:105, valueFormatter: numberFormatIntegerStr , cellStyle:numericCellStyleChecker},
                {headerName: 'Net', field: 'brokerNet', width:95, valueFormatter: params => params.value ? numberFormat4FractionalDigits(params): '', cellStyle:numericCellStyleChecker},
                {headerName: 'Interest', field: 'brokerInterest',width:100, cellStyle:numericCellStyleChecker},
                {headerName: 'Commission', field: 'brokerCommission',width:125,cellStyle:numericCellStyleChecker},
                {headerName: 'Exec Brk', field: 'brokerExecBroker',width:100},
                {headerName: 'DTC Control Number', field: 'brokerDtcControlNumber', width:170},
                {headerName: 'Reason', field: 'brokerReason', width:150},
            ]},

    ];

    const detailCellRendererParams = () => {
        return {
            detailGridOptions: {
                columnDefs:[
                    {headerName: '', field: 'type', width:80},
                    {headerName: 'Trade Date', field: 'TradeDate', valueGetter: clientOrBrokerData,width:115},
                    {headerName: 'Settle Date', field: 'SettleDate', valueGetter: clientOrBrokerData, width:115},
                    {headerName: 'Tran Type', field: 'TranType', valueGetter: clientOrBrokerData, width:110},
                    {headerName: 'Price', field: 'Price', valueGetter: clientOrBrokerData,width:95, cellStyle:numericCellStyleChecker},
                    {headerName: 'Quantity', field: 'Quantity', valueGetter: clientOrBrokerData, width:105, valueFormatter: numberFormatIntegerStr, cellStyle:numericCellStyleChecker},
                    {headerName: 'Net', field: 'Net', valueGetter: clientOrBrokerData,width:130, valueFormatter: params => params.value ? numberFormat4FractionalDigits(params): '', cellStyle:numericCellStyleChecker},
                    {headerName: 'Interest', field: 'Interest', valueGetter: clientOrBrokerData, width:100, cellStyle:numericCellStyleChecker},
                    {headerName: 'Commission', field: 'Commission', valueGetter: clientOrBrokerData, width:125, cellStyle:numericCellStyleChecker},
                    {headerName: 'Exec Brk', field: 'ExecBroker', valueGetter: clientOrBrokerData, width:100},
                    {headerName: 'DTC Control Number', field: 'brokerDtcControlNumber', width:170},
                    {headerName: 'Reason', field: 'brokerReason', width:400},
                    {headerName: '', flex: 1},
                ],
                onGridReady: function(params) {
                    params.api.setDomLayout('autoHeight');
                },
            },
            getDetailRowData: (params) => {
                let newerExpandedRows = []
                const brokerData = {"type": "Broker"};
                const clientData = {"type": "Client"};

                Object.entries(params.data).forEach(([key, value]) => {
                    if (key.startsWith('client')) {
                        clientData[key] = value;
                    }
                    if (key.startsWith('broker')) {
                        brokerData[key] = value;
                    }
                });
                if (clientData.clientTradeDate !==null && clientData.clientSettleDate !==null) newerExpandedRows.push(clientData)
                if (brokerData.brokerTradeDate !==null && brokerData.brokerSettleDate !==null) newerExpandedRows.push(brokerData)
                params.successCallback([...newerExpandedRows]);
            },
            template: '<Row ref="eDetailGrid" className="detail-grid"></Row>'
        };
    };

    const onFilterChanged = (gridApi, tradeBreakAgridFilterStateSessnAtr) => {
        if (gridApi) {
            const filterState = gridApi.getFilterModel();
            setSessionAttribute(tradeBreakAgridFilterStateSessnAtr, filterState);
        }
    };

    const restoreTradeBreakFilterState = (isGridReady, gridApi, rowData, tradeBreaksAgridFilterState) => {
        if (isGridReady && gridApi && rowData.length > 0) {
            const savedFilterState = getSessionAttribute(tradeBreaksAgridFilterState);
            if (savedFilterState) {
                // Small delay to ensure grid is fully rendered
                setTimeout(() => {
                    try {
                        gridApi.setFilterModel(savedFilterState);
                    } catch (error) {
                        console.error("Error restoring filter model:", error);
                    }
                }, 100);
            }
        }
    }

    //Entity Accounts related functions

    const loadAccountOptionsOnManagerChange = (managerId) => {
        if(managerId === dropDownOptionAll) {
            setCurAccountsOptions([defaultCurAccountsOptions]);
            return 0;
        }
        let accountsForEntity = getAccountsForSelectedEntity(managerId);

        if (accountsForEntity) {
            const availableAccountsOptions = [defaultCurAccountsOptions, ...JSON.parse(JSON.stringify(accountsForEntity))]
            setCurAccountsOptions(availableAccountsOptions);
            return availableAccountsOptions.length;
        }
        setCurAccountsOptions([]);
        return 0;
    }

    const getAccountsForSelectedEntity = (selectedManagerId) => {

        if(selectedManagerId === dropDownOptionAll)
            return null;

        let managerAccounts = entityAccountsOptionsNoSwap.find(({ managerId }) => managerId.toString() === selectedManagerId.toString());

        if (managerAccounts) {
            return managerAccounts.accounts;
        }
        return null;
    };

    const setCurManagerAndAccountDetails = (managerId, managerName, accountId, accountName, accountCode, showAccounts) => {

        curEntityAccounts.managerId = managerId;
        curEntityAccounts.managerName = managerName;
        curEntityAccounts.accountId = accountId;
        curEntityAccounts.accountName = accountName;
        curEntityAccounts.accountCode = accountCode;
        curEntityAccounts['formErrors']['search']['entity'] = '';
        curEntityAccounts['formErrors']['search']['account'] = '';

        curEntityAccounts.showAccounts = showAccounts;

        const loadAccountOptionsOnManagerChangeReturnCode= loadAccountOptionsOnManagerChange(managerId);

        if(showAccounts) {
            if(loadAccountOptionsOnManagerChangeReturnCode === 0){
                curEntityAccounts.accountId = '';
                curEntityAccounts.accountName = '';
                curEntityAccounts.accountCode = null;
            }
        }

        setCurEntityAccounts(curEntityAccounts);
        const correspondingEntity = getMemoizedEntityAccountsNoSwap.find((entity) => entity.managerId === managerId);
        if (correspondingEntity) {
            const selectedEntity = {}
            selectedEntity['managerId'] = correspondingEntity['managerId'];
            selectedEntity['managerName'] = correspondingEntity['shortName'] + '-' + correspondingEntity['longName'];
            setSessionAttribute(SELECTED_TRADE_BREAKS_ENTITY, selectedEntity);
        }
    }

    const setCurManagerDetailsWithOptionalAccount = (managerId, managerName, flag) => {
        const newEntityAccounts = JSON.parse(JSON.stringify(curEntityAccounts));
        newEntityAccounts.managerId = managerId;
        newEntityAccounts.managerName = managerName;
        newEntityAccounts.showAccounts = flag;
        newEntityAccounts['formErrors']['search']['entity'] = '';

        loadAccountOptionsOnManagerChange(managerId);
        setCurEntityAccounts(newEntityAccounts);
    };

    const setCurAccountDetails = (accountId, accountName, accountCode) => {
        const newEntityAccounts = {...curEntityAccounts};
        newEntityAccounts.accountId = accountId;
        newEntityAccounts.accountName = accountName;
        newEntityAccounts.accountCode = accountCode;
        newEntityAccounts['formErrors']['search']['account'] = '';
        setCurEntityAccounts(newEntityAccounts);
    };


    const populateDefaultCurEntity = (flag) => {
        const selectedEntityFromSession = getSessionAttribute(SELECTED_TRADE_BREAKS_ENTITY);
        const selectedAccountFromSession = getSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT);
        const selectedEntity = {};
        selectedEntity['managerId']=dropDownOptionAll;
        selectedEntity['managerName']=dropDownOptionAll;
        setSessionAttribute(SELECTED_TRADE_BREAKS_ENTITY,selectedEntity);
        setSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT, {accountId: dropDownOptionAll, name: dropDownOptionAll, accountCode: dropDownOptionAll});
        if(selectedEntityFromSession !== null && selectedAccountFromSession !== null){
            setCurManagerAndAccountDetails(selectedEntityFromSession.managerId, selectedEntityFromSession.managerName, selectedAccountFromSession.accountId, selectedAccountFromSession.name, selectedAccountFromSession.accountCode, flag);
        }
        else if(selectedEntityFromSession !== null){
            setCurManagerDetailsWithOptionalAccount(selectedEntityFromSession.managerId, selectedEntityFromSession.managerName, flag);
            setSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT, {accountId: '', name: '', accountCode: null});
        }
        else if(entityAccountsOptionsNoSwap && entityAccountsOptionsNoSwap.length > 0) {
            setCurManagerDetails(dropDownOptionAll,dropDownOptionAll);
        }
    }

    const setInitCurEntityAccountsOptions = () => {
        const userEntityAccountsNoSwap = getMemoizedEntityAccountsNoSwap
        const entityAccountsOptionsNoSwap = JSON.parse(JSON.stringify(userEntityAccountsNoSwap))
        setEntityAccountsOptionsNoSwap(entityAccountsOptionsNoSwap);
        setSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP, entityAccountsOptionsNoSwap);
    }

    const setCurShowAccounts = (flag) => {
        setCurEntityAccounts({...curEntityAccounts, ['showAccounts']:flag, ['validateAccount']:true});
    };

    const setShowCurAccountValidateAccount = (showFlag,validateAccountFlag) => {
        setCurEntityAccounts({...curEntityAccounts, ['showAccounts']:showFlag ?? true, ['validateAccount']:validateAccountFlag ?? true});
    };


    const clearCurEntityAccounts = (showAccountFlag, validateAccountFlag) => {
        setSessionAttribute(SELECTED_TRADE_BREAKS_ENTITY, null);
        setSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT, null);
        setInitCurEntityAccountsOptions();
        populateDefaultCurEntity(true)
        if (showAccountFlag !== undefined)
            setCurShowAccounts(showAccountFlag);
        if (validateAccountFlag !== undefined)
            setShowCurAccountValidateAccount(showAccountFlag, validateAccountFlag);
    };

    const setCurManagerDetails = (managerId, managerName) => {
        const newEntityAccounts = JSON.parse(JSON.stringify(curEntityAccounts));
        newEntityAccounts.managerId = managerId;
        newEntityAccounts.managerName = managerName;
        newEntityAccounts['formErrors']['search']['entity'] = '';
        newEntityAccounts.accountId = '';
        newEntityAccounts.accountName = '';
        newEntityAccounts.accountCode = null;

        loadAccountOptionsOnManagerChange(managerId);
        setCurEntityAccounts(newEntityAccounts);
    };

    const clearTradeBreaksFilterState = () => {
        const clearTradeBreakFilterState = JSON.parse(JSON.stringify(initTradeBreakFilterState));
        setTradeBreakFilterState(clearTradeBreakFilterState);
    }

    const numberFormatHelper = (field, value) => {
        if(['quantity'].includes(field.toLowerCase())){
            return numberFormatIntegerStr({value: value});
        }
        if(['quantity','net','interest','commission'].includes(field.toLowerCase())){
            return numberFormat4FractionalDigits({value: value});
        }
        return value;
    }

    const tradeBreakContext = {
        popUpData,
        setPopUpData,
        showInfoModal,
        setShowInfoModal,
        tradeBreakTypeHashmap,
        columnDefsTradeBreaks,
        selectedBrkType,
        setSelectedBrkType,
        selectedBreak,
        mapTradeBreakType,
        accountCodeMapping,
        cellStyleChecker,
        getReasonEquivalentOfField,
        setSelectedBreak,
        highlightTradeEntryFields,
        setHighlightTradeEntryFields,
        viewClicked, setViewClicked,
        loadTradeBreaksList,
        gridApi, setGridApi, rowData, setRowData, gridColumnApi,setGridColumnApi, loadTradeBreaksListWithParams,
        initTradeBreakFilterState, tradeBreakFilterState, setTradeBreakFilterState,
        detailCellRendererParams, columnDefsTradeBreaksOriginal,
        isTradeBreaksFilterOpen, setIsTradeBreaksFilterOpen, restoreTradeBreakFilterState, onFilterChanged
        , populateDefaultCurEntity, curEntityAccounts,setCurAccountDetails, getAccountsForSelectedEntity
        , clearCurEntityAccounts, setCurManagerDetails, curAccountsOptions, gridApiOriginal, setGridApiOriginal, clearFilterData, tradeBreakFilterClearClicked, setTradeBreakFilterClearClicked, clearTradeBreaksFilterState,
        numberFormatHelper, getRefreshCriteria
    }

    return <Context.Provider value={tradeBreakContext}>{children}</Context.Provider>

};

export const {Consumer} = Context;
